import axios from 'axios';

const API_HOST = process.env.REACT_APP_API_BASE_PATH;

export const getMessagesData = params =>
  axios.get(`${API_HOST}/messages`, { params, withCredentials: true });

export const deleteMessageData = messageId =>
  axios.delete(`${API_HOST}/messages/${messageId}`, { withCredentials: true });
